import { eventTimeFormats } from '../../configuration/calendar'
import labels from '../../configuration/labels'

export function formatEventTime(startDate, endDate, timeFormat = 'h:mma', eventTimeFormat) {
  const startTime = startDate?.isValid() ? startDate?.format(timeFormat) : ''
  const endTime = endDate?.isValid() ? endDate?.format(timeFormat) : ''

  switch (eventTimeFormat) {
    case eventTimeFormats.fromStartTime:
      return startTime ? `${labels.eventCardsLabelFrom}: ${startTime}` : ''

    case eventTimeFormats.startTime:
      return startTime
      
    case eventTimeFormats.startTimeEndTime:
    default:
      if (startTime && endTime) return `${startTime} - ${endTime}`
      if (startTime) return startTime
      if (endTime) return endTime
      return ''
  }
}
